export const parseArrayFromString = (input: string): string[] | void => {
    try {
        const result = new Array<string>();
        const parsed = JSON.parse(input);
        if (Array.isArray(parsed)) {
            parsed.forEach(entry => {
                if (typeof entry === 'string') {
                    result.push(entry);
                }
            });
        }
        return result;
    } catch {}
};
